:root {
  --theme-color: transparent;
  --section-inactive: rgb(231, 230, 232);
}
.reset-button {
  display: inline-block;
  border: 3px solid #ddd;
  padding: 4px 6px 2px 6px;
  border-radius: 50%;
  transition: background-color 200ms;
}
.reset-button:hover {
  background-color: #ddd;
}

.reset-button svg {
  width: 20px;
  height: 20px;
}

g.active > path,
g.active > polygon,
g.active > rect {
  fill: var(--theme-color);
}

g.active.selected > path,
g.active.selected > polygon,
g.active.selected > rect {
  fill: rgba(39, 174, 96, 0.5) !important;
  stroke: #646464;
  stroke-width: 1px;
  stroke-linejoin: round;
}

g.active text {
  fill: white;
}

g .inactive text {
  fill: #cccccc;
}

#my-map .inactive {
  pointer-events: none;
}

#mymap * {
  user-select: none;
}

#mymap text {
  font-family: inherit;
}
